import { ProgressBar } from 'components/common';

const FileUploaderInProgress = ({ theme, text }) => (
  <div className="transcoding">
    <div className="status">
      {text}
    </div>

    <div className="progress">
      <ProgressBar
        animate={true}
        color={theme.mainColor}
        progress={1}
        progressAnimation={false}
        progressStyle={{borderRadius: 4, height: 8}}
      />
    </div>

    <style jsx>{`
      .status {
        font-size: 1.3rem;
        font-weight: 600;
        text-align: center;
      }
      .progress {
        margin-top: 10px;
        text-align: left;
      }
    `}</style>
  </div>
);

export default FileUploaderInProgress;
